export { default } from './RichText';
export type { RichTextContentProps } from './types';
